import { InputLabel } from '@/components/ui/InputLabel';

export const DEFAULT_TEXT_FIELD_MAX_LENGTH = 200;

interface TextFieldWithLimitProps {
  label: string;
  value?: string;
  onChange: (value: string) => void;
  maxLength?: number;
  type?: 'text' | 'email' | 'url' | 'tel';
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  className?: string;
  classNameInput?: string;
  error?: string;
}

export function TextFieldWithLimit({
  label,
  value,
  onChange,
  maxLength = DEFAULT_TEXT_FIELD_MAX_LENGTH,
  type,
  multiline,
  rows,
  disabled,
  readOnly,
  placeholder,
  className,
  classNameInput,
  error,
}: TextFieldWithLimitProps) {
  const current = value?.length ?? 0;
  const isOver = current > maxLength;
  const counterClass = isOver ? 'text-error' : 'text-secondary';

  return (
    <div className="flex flex-col gap-1">
      <InputLabel
        label={label}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        maxLength={maxLength}
        type={type}
        multiline={multiline}
        rows={rows}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={placeholder}
        className={className}
        classNameInput={classNameInput}
      />
      <div className="flex items-center justify-between">
        {error ? <p className="text-xs text-error">{error}</p> : <span />}
        <p className={`text-xs ${counterClass}`}>
          {current}/{maxLength}
        </p>
      </div>
    </div>
  );
}
